import { render, staticRenderFns } from "./DottoreDetail.vue?vue&type=template&id=52f3e2d3&"
import script from "./DottoreDetail.vue?vue&type=script&lang=ts&"
export * from "./DottoreDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports